/**
 * @file useServiceRecordsPref.ts
 * @description «Служебные записи показаны / свёрнуты» — выбор сотрудника
 * (chat-window-design.md §3, §6): в `localStorage` за сотрудником, общий для
 * всех вкладок и магазинов. По умолчанию показаны.
 */

import { useCallback, useState } from "react";

import { chatStorageKeys } from "./chat-window-state";

const COLLAPSED = "collapsed";

export function useServiceRecordsPref(userId: string) {
  const key = chatStorageKeys.service(userId);
  const [shown, setShown] = useState(() => window.localStorage.getItem(key) !== COLLAPSED);

  const toggle = useCallback(() => {
    setShown((prev) => {
      const next = !prev;
      if (next) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, COLLAPSED);
      return next;
    });
  }, [key]);

  return [shown, toggle] as const;
}
